module.exports = require("@splunk/visualization-context/IconContext");